import React from 'react';
import ChatBotPage from 'core/views/admin/ChatBotPage';

const ChatBot = () => <ChatBotPage />;

export default ChatBot;
